import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import UserAvatarImage from '../user-avatar-image';
import QuickUserInfo from '../quick-user-info';
import MemberCardAsync from '../../containers/member-card-async';
import ProfileLink from '../link/profile-link';
import styles from './avatar.scss';

function Avatar({ type, user = {}, date, showDate, showBadges }) {
  const className = classNames(
    styles.container,
    'forum-text-color',
    { [styles[type]]: type },
    'avatar',
  );
  return (
    <div className={classNames(className)}>
      <MemberCardAsync viewedMemberId={user.siteMemberId} className={styles.link}>
        <ProfileLink user={user} className={styles.profileLink}>
          <UserAvatarImage type={type} user={user} />
        </ProfileLink>
      </MemberCardAsync>
      <div className={styles.profileInfo}>
        <ProfileLink user={user} className={styles.link}>
          <span
            className={classNames(styles.name, 'forum-text-color', 'forum-link-hover-color')}
            data-hook="avatar__name"
          >
            {user.name}
          </span>
        </ProfileLink>
        <QuickUserInfo user={user} date={date} showDate={showDate} showBadges={showBadges} />
      </div>
    </div>
  );
}

Avatar.LARGE = 'large';
Avatar.MEDIUM = 'medium';

Avatar.propTypes = {
  user: PropTypes.object.isRequired,
  type: PropTypes.string,
  date: PropTypes.string,
  showDate: PropTypes.bool,
  showBadges: PropTypes.bool,
};

Avatar.defaultProps = {
  showBadges: true,
};

export default Avatar;
